import styleInject from './../external/.pnpm/style-inject@0.3.0/external/style-inject/dist/style-inject.es.js';

var css_248z = "";
var breakpoints = {"xs":"0px","sm":"600px","md":"900px","lg":"1200px","xl":"1536px"};
styleInject(css_248z);

export { breakpoints as default };
